import React from 'react';

export default props => (
  <div style={{width: '100%', height: props.space || props.spacing || props.height || props.margin}} />
);
